
import Vue, { PropType } from "vue";
import { mapState } from "vuex";
import { PurchaseEntryItem } from "@/config/purchase-entry";
import { dispatch } from "@/store";

type PurchaseEntryVariant =
  | "header-icon"
  | "header-menu"
  | "header-buy"
  | "banner-buttons";

export default Vue.extend({
  name: "VPurchaseEntry",
  props: {
    items: {
      type: Array as PropType<PurchaseEntryItem[]>,
      required: true
    },
    variant: {
      type: String as PropType<PurchaseEntryVariant>,
      default: "header-icon"
    },
    triggerLabel: {
      type: String,
      default: "BUY"
    },
    accentColor: {
      type: String,
      default: "#ff5a1f"
    }
  },
  data() {
    return {
      isOpen: false,
      closeTimer: 0,
      amazonIcon: require("@/assets/images/amazon-icon.svg")
    };
  },
  computed: {
    ...mapState("app", {
      isMobile: "isMobile"
    }),
    ...mapState("assets", {
      images: "images"
    }),
    styleVars(): Record<string, string> {
      return {
        "--purchase-accent": this.accentColor
      };
    },
    isSinglePanel(): boolean {
      return this.variant !== "banner-buttons" && this.items.length === 1;
    }
  },
  methods: {
    isExpandable(): boolean {
      return this.variant !== "banner-buttons";
    },
    isAmazonItem(item: PurchaseEntryItem): boolean {
      return item.key === "amazon";
    },
    panelLabel(item: PurchaseEntryItem): string {
      if (item.key === "store") {
        return "Official Store";
      }
      return item.label;
    },
    clearCloseTimer() {
      if (this.closeTimer) {
        window.clearTimeout(this.closeTimer);
        this.closeTimer = 0;
      }
    },
    openOnHover() {
      if (!this.isMobile && this.isExpandable()) {
        this.clearCloseTimer();
        this.isOpen = true;
      }
    },
    closeOnHover() {
      if (!this.isMobile && this.isExpandable()) {
        this.clearCloseTimer();
        this.closeTimer = window.setTimeout(() => {
          this.isOpen = false;
          this.closeTimer = 0;
        }, 360);
      }
    },
    toggleOpen() {
      if (!this.isExpandable()) {
        return;
      }
      this.clearCloseTimer();
      this.isOpen = !this.isOpen;
    },
    closePanel() {
      this.clearCloseTimer();
      this.isOpen = false;
    },
    onItemClick(item: PurchaseEntryItem, event: MouseEvent) {
      if (item.action === "orderNow") {
        event.preventDefault();
        dispatch.orderNow();
      }
      this.closePanel();
    },
    onDocumentClick(event: MouseEvent) {
      const root = this.$refs.root as HTMLElement | undefined;
      if (!root || root.contains(event.target as Node)) {
        return;
      }
      this.clearCloseTimer();
      this.isOpen = false;
    }
  },
  mounted() {
    document.addEventListener("click", this.onDocumentClick);
  },
  beforeDestroy() {
    this.clearCloseTimer();
    document.removeEventListener("click", this.onDocumentClick);
  }
});
